import { createSlice } from '@reduxjs/toolkit';
import { staticVar } from '../services/Constants';

const initialState = {
    data: {
        header: true,
        sidebar: true,
    },
    status: staticVar.idle
};

const utilsSlice = createSlice({
    name: 'utilsData',
    initialState,
    reducers: {
        updateSidebar: (state, action) => {
            state.data.sidebar = action.payload;
        },
        updateHeader: (state,action) => {
            state.data.header = action.payload;
        },
        updateUtils: (state,action) => {
            const data = JSON.parse(JSON.stringify(state.data));
            state.data = {
                ...data,
                ...action.payload
            }
        },
        resetUtilsSlice: (state) => {
            state.data = initialState.data;
            state.status = initialState.status;
        },
    }
});

export const selectUtilsData = (state) => state.utilsData.data;
export const { updateUtils, updateSidebar, updateHeader,resetUtilsSlice} = utilsSlice.actions;
export default utilsSlice.reducer;